<template>

  <v-dialog v-model="localValue" max-width="640">
    <v-card class="pa-0">
      <v-toolbar flat dense>
        <v-btn v-if="mode === 'form'" icon @click="backToList" aria-label="voltar">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>{{ mode === 'list' ? 'NOTÍCIAS' : (isEditing ? 'Editar notícia' : 'Nova notícia') }}</v-toolbar-title>
        <v-spacer />
        <template v-if="mode === 'list'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="btn-info-limit"
                v-bind="attrs"
                v-on="on"
                aria-label="limite de notícias"
                title="Máximo de 3 notícias ativas por rede."
              >
                <v-icon color="warning">info_outline</v-icon>
              </v-btn>
            </template>
            <span>Máximo de 3 notícias por rede.</span>
          </v-tooltip>
          <v-btn icon @click="cadastrarNoticia" aria-label="nova notícia" class="btn-nova">
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <v-btn icon @click="close" aria-label="fechar">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="py-4">
        <v-container fluid>
          <v-slide-x-transition mode="out-in">
            <!-- LISTA -->
            <div v-if="mode === 'list'" key="list">
              <v-row>
                <v-col cols="12">
                  <div v-if="loading" class="text-center pa-4">
                    <v-progress-circular indeterminate size="36" />
                  </div>

                  <div v-else>
                    <div class="table-wrap">
                      <v-simple-table class="noticias-table" dense>
                        <thead>
                          <tr>
                            <th class="col-desc">Descrição</th>
                            <th class="col-date">Data início</th>
                            <th class="col-date">Data fim</th>
                            <th class="col-active">Ativo</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in noticias" :key="item.id_noticia">
                            <td class="td-desc">{{ item.descricao }}</td>
                            <td>{{ formatDate(item.data_inicio) }}</td>
                            <td>{{ formatDate(item.data_fim) }}</td>
                            <td>
                              <div class="acoes">
                                <v-chip
                                  small
                                  :color="item.ativo ? 'green' : 'grey'"
                                  dark
                                  clickable
                                  :disabled="!!toggling[item.id_noticia]"
                                  :title="item.ativo ? 'Desativar' : 'Ativar'"
                                  @click="ativarNoticia(item)"
                                >
                                  {{ item.ativo ? 'Sim' : 'Não' }}
                                </v-chip>

                                <v-btn
                                  icon
                                  x-small
                                  aria-label="editar notícia"
                                  @click="editarNoticia(item)"
                                >
                                  <v-icon>edit</v-icon>
                                </v-btn>

                                <v-btn
                                  icon
                                  x-small
                                  :disabled="!!deleting[item.id_noticia]"
                                  aria-label="excluir notícia"
                                  @click="openDeleteConfirm(item)"
                                >
                                  <v-icon v-if="!deleting[item.id_noticia]" color="error">delete</v-icon>
                                  <v-progress-circular v-else indeterminate size="12" width="2" />
                                </v-btn>
                              </div>
                            </td>
                          </tr>
                          <tr v-if="!noticias.length">
                            <td colspan="4" class="text-center">Nenhuma notícia encontrada.</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div v-else key="form">
              <v-form ref="formCreate" v-model="formValid" lazy-validation>
                <v-text-field
                  v-model="form.descricao"
                  label="Descrição"
                  :rules="[rules.required]"
                  clearable
                  autofocus
                />
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="form.data_inicio"
                      label="Data início"
                      type="date"
                      :rules="[rules.required]"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="form.data_fim"
                      label="Data fim"
                      type="date"
                      :rules="endDateRules"
                    />
                  </v-col>
                </v-row>
              </v-form>

              <div class="d-flex justify-end mt-2">
                <v-btn text @click="backToList" :disabled="createLoading">Cancelar</v-btn>
                <v-btn color="primary" class="ml-2" :loading="createLoading" :disabled="!formValid" @click="salvarNoticia">
                  Salvar
                </v-btn>
              </div>
            </div>
          </v-slide-x-transition>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog v-model="confirmDeleteOpen" max-width="420">
      <v-card>
        <v-card-title class="headline">Confirmar exclusão</v-card-title>
        <v-card-text>
          Tem certeza que deseja excluir a notícia
          <strong>{{ itemToDelete ? (itemToDelete.descricao || 'esta notícia') : '' }}</strong>?
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn text @click="closeDeleteConfirm" :disabled="confirmDeleteLoading">Cancelar</v-btn>
          <v-btn color="error" :loading="confirmDeleteLoading" @click="confirmDelete">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogNoticias',
  props: {
    value: { type: Boolean, default: false },
    redeId: { type: [Number, String], default: null }
  },
  data () {
    return {
      localValue: this.value,
      noticias: [],
      loading: false,
      toggling: {},
      deleting: {},
      mode: 'list',
      createLoading: false,
      formValid: false,
      isEditing: false,
      editId: null,
      confirmDeleteOpen: false,
      confirmDeleteLoading: false,
      itemToDelete: null,
      form: {
        descricao: '',
        data_inicio: '',
        data_fim: ''
      },
      rules: {
        required: v => !!v || 'Obrigatório'
      }
    }
  },
  watch: {
    value (v) {
      this.localValue = v
      if (v) this.fetch()
    },
    localValue (v) {
      this.$emit('input', v)
    }
  },
  mounted () {
    if (this.localValue) {
      this.fetch()
    }
  },
  computed: {
    endDateRules () {
      return [
        this.rules.required,
        (v) => {
          const s = this.form.data_inicio
          if (!s || !v) return true
          return v >= s || 'Data fim deve ser maior ou igual à data início'
        }
      ]
    }
  },
  methods: {
    close () {
      this.localValue = false
    },
    async ativarNoticia (item) {
      const id = item.id_noticia || item.id
      if (!id) return
      const novoAtivo = !item.ativo
      this.$set(this.toggling, id, true)
      try {
        await this.$store.dispatch('salvarNoticia', { id, ativo: novoAtivo })
        this.$set(item, 'ativo', novoAtivo)
        this.$emit('showSnackbar', 'success', 'Status da notícia atualizado.')
      } catch (err) {
        console.error(err)
        this.$emit('showSnackbar', 'error', 'Não foi possível atualizar o status da notícia.')
      } finally {
        this.$delete(this.toggling, id)
      }
    },
    async fetch () {
      this.loading = true
      try {
        const list = await this.$store.dispatch('listarNoticias', this.redeId)
        this.noticias = Array.isArray(list) ? list : (list.results || [])
      } catch (err) {
        this.$emit('showSnackbar', 'error', 'Erro ao carregar notícias.')
      } finally {
        this.loading = false
      }
    },
    formatDate (iso) {
      if (!iso) return ''
      const d = new Date(iso)
      if (Number.isNaN(d.getTime())) {
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(iso)) return iso
        return String(iso)
      }
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      return `${day}/${month}/${year}`
    },
    toDateInput (val) {
      if (!val) return ''
      if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val
      if (typeof val === 'string' && val.includes('T')) return val.slice(0, 10)
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) {
        const [d, m, y] = val.split('/')
        return `${y}-${m}-${d}`
      }
      const d = new Date(val)
      if (!Number.isNaN(d.getTime())) {
        const yy = d.getFullYear()
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const dd = String(d.getDate()).padStart(2, '0')
        return `${yy}-${mm}-${dd}`
      }
      return ''
    },
    cadastrarNoticia () {
      this.resetCreate()
      this.isEditing = false
      this.editId = null
      this.mode = 'form'
    },
    editarNoticia (item) {
      this.resetCreate()
      this.isEditing = true
      this.editId = item.id_noticia
      this.form = {
        descricao: item.descricao || '',
        data_inicio: this.toDateInput(item.data_inicio),
        data_fim: this.toDateInput(item.data_fim)
      }
      this.mode = 'form'
    },
    backToList () {
      if (this.createLoading) return
      this.mode = 'list'
    },
    resetCreate () {
      this.form = { descricao: '', data_inicio: '', data_fim: '' }
      this.formValid = false
      this.$nextTick(() => {
        if (this.$refs.formCreate) this.$refs.formCreate.resetValidation()
      })
    },
    async salvarNoticia () {
      const ok = this.$refs.formCreate && this.$refs.formCreate.validate()
      if (!ok) return

      this.createLoading = true
      try {
        const payload = {
          id_rede: this.redeId,
          descricao: this.form.descricao,
          data_inicio: this.form.data_inicio,
          data_fim: this.form.data_fim
        }
        if (this.isEditing && this.editId) {
          payload.id = this.editId
        }

        await this.$store.dispatch('salvarNoticia', payload)

        this.$emit('showSnackbar', 'success', this.isEditing ? 'Notícia atualizada.' : 'Notícia cadastrada.')
        this.mode = 'list'
        await this.fetch()
      } catch (err) {
        console.error(err)
        this.$emit('showSnackbar', 'error', 'Não foi possível salvar a notícia.')
      } finally {
        this.createLoading = false
      }
    },
    async deletarNoticia (item) {
      const id = item.id_noticia || item.id
      if (!id) return

      this.$set(this.deleting, id, true)
      try {
        await this.$store.dispatch('deletarNoticia', id)
        this.noticias = this.noticias.filter(n => {
          const nid = n.id_noticia || n.id
          return nid !== id
        })
        this.$emit('showSnackbar', 'success', 'Notícia excluída.')
      } catch (err) {
        this.$emit('showSnackbar', 'error', 'Não foi possível deletar a notícia.')
      } finally {
        this.$delete(this.deleting, id)
      }
    },
    openDeleteConfirm (item) {
      this.itemToDelete = item
      this.confirmDeleteOpen = true
    },
    closeDeleteConfirm () {
      if (this.confirmDeleteLoading) return
      this.confirmDeleteOpen = false
      this.itemToDelete = null
    },
    async confirmDelete () {
      if (!this.itemToDelete) return
      this.confirmDeleteLoading = true
      try {
        await this.deletarNoticia(this.itemToDelete)
        this.confirmDeleteOpen = false
        this.itemToDelete = null
      } finally {
        this.confirmDeleteLoading = false
      }
    }
  }
}
</script>

<style scoped>
.noticias-table {
  width: 100%;
  border-collapse: collapse;
}
.noticias-table th,
.noticias-table td {
  padding: 8px 10px;
  border-bottom: 1px solid rgba(0,0,0,0.08);
  text-align: left;
  vertical-align: middle;
}
.noticias-table thead th {
  font-weight: 600;
}
.acoes {
  display: inline-flex;
  align-items: center;
  gap: 6px;            /* espaço entre chip e botões */
  white-space: nowrap; /* evita quebrar para a linha de baixo */
}
.text-center { text-align: center; }
.btn-nova { margin-left: 12px; }
.btn-info-limit { margin-left: 6px; }
</style>
